import { Component } from '@angular/core'
import { TooltipComponent } from '../tooltip.component'

/**
 * Important: This is an internal component for the Tooltip directive, not to be used alone
 */
@Component({
  selector: 'ftr-tooltip-unpadded',
  templateUrl: '../tooltip.component.html',
  styleUrls: ['tooltip.unpadded.component.css'],
})
export class TooltipUnpaddedComponent extends TooltipComponent {}
